@if (tpisInfoForm) {
  <form class="contain" [formGroup]="tpisInfoForm">
    <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
      <h2 class="bold-header" dsContent [contentPath]="headerContentPath"></h2>
      <div>
        <ds-radio-group
          [control]="'tpiOption'"
          [selectedAnswer]=""
          [parentFormGroup]="tpisInfoForm"
          [options]="tpiDescriptionList$ | async"
        >
        </ds-radio-group>
      </div>
    </div>
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <call-to-action
        [displayBackButton]="true"
        [disabled]="tpisInfoForm.invalid"
        [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
        (primaryEvent)="submitTPIsInfo()"
        (backEvent)="goBackOneStep()"
        tertiaryButtonName="Cancel"
        (tertiaryEvent)="cancel()"
      >
      </call-to-action>
    </div>
  </form>
}

<ds-exit-flow-modal
  [exitFlowModalId]="exitFlowModalId"
  [isPartner]="isPartner$ | async"
  (exit)="navigateToOverview()"
  (cancelModal)="stay()"
  (notifyAgent)="sendToAgent()"
></ds-exit-flow-modal>
